import type { ProductArea } from '../productdetails/ProductOriginLinks';
import ProductOriginLinks from '../productdetails/ProductOriginLinks';
import * as style from './ProductRegion.module.css';

export default function ProductRegion({ product }: { product: ProductArea }) {
    return (
        <p className={style.productRegion} data-track-link-click="product-region">
            <ProductOriginLinks product={product} />
        </p>
    );
}
